import noop from 'lodash-es/noop'
import { createContext } from 'react'

import { Asset } from '@/lib/features/Assets/interfaces'

type ActiveAssetContextValue = {
  activeAsset?: Asset
  setActiveAsset: (asset: Asset) => void
  clearActiveAsset: () => void
}

export const ActiveAssetContext = createContext<ActiveAssetContextValue>({
  activeAsset: undefined,
  setActiveAsset: noop,
  clearActiveAsset: noop,
})
